<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";


export default {
    page: { title: "BTHK Raporu" },
    components: { Layout, PageHeader },
    data() {
        return {
            title: 'BTHK Raporu',
            items: [
                { text: 'ANASAYFA', href: '/' },
                { text: 'BTHK RAPORU', active: true }
            ]
        ,
        snapshots: []
        }
    },
    computed: {
      latest() {
        if (!this.snapshots.length) return null;
        return [...this.snapshots].sort((a, b) => (b.year - a.year) || (b.quarter - a.quarter))[0];
      }
    },
    methods: {
      fetchSnapshots() {
        this.$http.get('/reports/bthk/list').then(res => {
          this.snapshots = res.data || [];
        }).catch(() => {});
      },
      n(v) {
        return Number(v) || 0;
      },
      kayitli(row) {
        return this.n(row.infrastructure_xdsl) + this.n(row.infrastructure_wireless) + this.n(row.infrastructure_fiber);
      },
      aktif(row) {
        return this.n(row.infrastructure_active_xdsl) + this.n(row.infrastructure_active_wireless) + this.n(row.infrastructure_active_fiber);
      },
      gelir(row) {
        return this.n(row.xdsl_revenue) + this.n(row.wireless_revenue) + this.n(row.fiber_revenue);
      },
      arpu(gelir, adet) {
        return adet > 0 ? (gelir / adet).toFixed(2) : '';
      },
      donem(row) {
        const start = ['01.01', '01.04', '01.07', '01.10'][row.quarter - 1];
        const end = ['31.03', '30.06', '30.09', '31.12'][row.quarter - 1];
        return start + '.' + row.year + '-' + end + '.' + row.year;
      },
      exportCsv(row) {
        this.$http.get(`/reports/bthk/${row.year}/${row.quarter}/export`, { responseType: 'blob' })
          .then((res) => {
            const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `BTHK RAPORU ${row.year} - ${row.quarter} Ceyrek.xlsx`;
            a.click();
            URL.revokeObjectURL(url);
          });
      }
    },
    mounted() {
      this.fetchSnapshots();
    }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div v-if="!latest" class="text-center">Rapor bulunamadı.</div>

            <div v-else class="mb-4">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <strong>{{ latest.year }} - Çeyrek {{ latest.quarter }}</strong>
                <button type="button" class="btn btn-sm btn-outline-primary" @click="exportCsv(latest)">Excel</button>
              </div>
              <table class="table table-sm table-bordered bthk-sheet">
                <tbody>
                  <tr><td>İnternet Servis Sağlayıcı Adı</td><td>PRİMENET İNTERNET SERVİS SAĞLAYICILIĞI LTD.</td></tr>
                  <tr><td>Dönem</td><td>{{ donem(latest) }}</td></tr>
                  <tr class="section"><td colspan="2">Aboneler (Subscribers)</td></tr>
                  <tr class="head"><td>Abone Bilgileri</td><td>#</td></tr>
                  <tr class="total"><td>Kayıtlı Toplam Abone Sayısı</td><td>{{ kayitli(latest) }}</td></tr>
                  <tr class="section"><td colspan="2">Kayıtlı Abone Sayısının Dağılımı</td></tr>
                  <tr><td>xDSL</td><td>{{ n(latest.infrastructure_xdsl) }}</td></tr>
                  <tr><td>Wireless</td><td>{{ n(latest.infrastructure_wireless) }}</td></tr>
                  <tr><td>Fiber</td><td>{{ n(latest.infrastructure_fiber) }}</td></tr>
                  <tr><td>Hotspot</td><td>0</td></tr>
                  <tr><td>Diğer (Lütfen belirtiniz)</td><td>0</td></tr>
                  <tr class="total"><td>Toplam Aktif Abone Sayısı</td><td>{{ aktif(latest) }}</td></tr>
                  <tr class="section"><td colspan="2">Aktif Abone Sayısının Dağılımı</td></tr>
                  <tr><td>xDSL</td><td>{{ n(latest.infrastructure_active_xdsl) }}</td></tr>
                  <tr><td>Wireless</td><td>{{ n(latest.infrastructure_active_wireless) }}</td></tr>
                  <tr><td>Fiber</td><td>{{ n(latest.infrastructure_active_fiber) }}</td></tr>
                  <tr><td>Hotspot</td><td>0</td></tr>
                  <tr><td>Diğer (Lütfen belirtiniz)</td><td>0</td></tr>
                  <tr class="total"><td>Çalışan Başına Abone Sayısı (Subscriber Per Employee)</td><td></td></tr>
                  <tr class="section"><td colspan="2">Sabit Genişbant İnternet Abone Sayıları</td></tr>
                  <tr><td>Bireysel</td><td>{{ n(latest.total_individual_subscribers) }}</td></tr>
                  <tr><td>Kurumsal</td><td>{{ n(latest.total_corporate_subscribers) }}</td></tr>

                  <tr class="section"><td colspan="2">Gelir (Revenue)</td></tr>
                  <tr class="total"><td>Dönem Net Geliri</td><td>{{ gelir(latest) }}</td></tr>
                  <tr class="total"><td>Toplam Gelir (Total Revenue) (TL)</td><td>{{ gelir(latest) }}</td></tr>
                  <tr><td>xDSL</td><td>{{ n(latest.xdsl_revenue) }}</td></tr>
                  <tr><td>Wireless</td><td>{{ n(latest.wireless_revenue) }}</td></tr>
                  <tr><td>Fiber</td><td>{{ n(latest.fiber_revenue) }}</td></tr>
                  <tr><td>Hotspot</td><td>0</td></tr>
                  <tr><td>Diğer (Lütfen belirtiniz)</td><td>0</td></tr>
                  <tr class="section"><td colspan="2">ARPU (Average Revenue Per Usage) (TL)</td></tr>
                  <tr><td>xDSL</td><td>{{ arpu(n(latest.xdsl_revenue), n(latest.infrastructure_active_xdsl)) }}</td></tr>
                  <tr><td>Wireless</td><td>{{ arpu(n(latest.wireless_revenue), n(latest.infrastructure_active_wireless)) }}</td></tr>
                  <tr><td>Fiber</td><td>{{ arpu(n(latest.fiber_revenue), n(latest.infrastructure_active_fiber)) }}</td></tr>
                  <tr><td>Hotspot</td><td></td></tr>
                  <tr><td>Diğer (Lütfen belirtiniz)</td><td></td></tr>
                  <tr class="total"><td>Toplam (Aggregate)</td><td>{{ arpu(gelir(latest), aktif(latest)) }}</td></tr>

                  <tr class="section"><td colspan="2">Kullanım (Usage) ve Trafik (Traffic)</td></tr>
                  <tr class="section"><td colspan="2">International fixed data bandwidth demand (Mbps)</td></tr>
                  <tr><td>Downstream</td><td></td></tr>
                  <tr><td>Upstream</td><td></td></tr>
                  <tr class="section"><td colspan="2">Sabit Genişbant İnternet Kullanımı</td></tr>
                  <tr><td>Download (Tbyte)</td><td></td></tr>
                  <tr><td>Upload (Tbyte)</td><td></td></tr>

                  <tr class="section"><td colspan="2">İnternet Hızına göre Sabit Genişbant İnternet Kullanımı</td></tr>
                  <tr><td>512 kBit/s</td><td>{{ n(latest.speed_under_20mbps) }}</td></tr>
                  <tr><td>1 Mbit/s</td><td>{{ n(latest.speed_equal_one) }}</td></tr>
                  <tr><td>2 Mbit/s</td><td>{{ n(latest.speed_equal_two) }}</td></tr>
                  <tr><td>3 Mbit/s</td><td>{{ n(latest.speed_equal_three) }}</td></tr>
                  <tr><td>4 Mbit/s</td><td>{{ n(latest.speed_equal_four) }}</td></tr>
                  <tr><td>5 Mbit/s</td><td>{{ n(latest.speed_equal_five) }}</td></tr>
                  <tr><td>8 Mbit/s</td><td>{{ n(latest.speed_6_8) }}</td></tr>
                  <tr><td>10 Mbit/s</td><td>{{ n(latest.speed_9_10) }}</td></tr>
                  <tr><td>&gt;10 Mbit/s</td><td>{{ n(latest.speed_above_10) }}</td></tr>
                  <tr><td>Diğer (Lütfen belirtiniz)</td><td>0</td></tr>

                  <tr class="section"><td colspan="2">Güvenli İnternet Hizmeti</td></tr>
                  <tr><td>Yararlanan abone sayısı</td><td>0</td></tr>
                  <tr><td>Yararlanmayan abone sayısı</td><td>0</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.card { border: 1px solid #e9ecef; }
.bthk-sheet { max-width: 720px; }
.bthk-sheet td:last-child { text-align: right; width: 160px; }
.bthk-sheet .head td { background: #4b1d7a; color: #fff; font-weight: 600; }
.bthk-sheet .section td { background: #4b1d7a; color: #fff; font-weight: 600; }
.bthk-sheet .total td { background: #d9d9d9; font-weight: 600; }
</style>
